<template>
    <div>
        <b-modal
            id="requestRefillModal"
            ref="requestRefillModal"
            :lazy="true"
            :no-close-on-backdrop="true"
            :title="title"
            title-tag="h2"
        >
            <div class="mb-3">
                <p>A request for refill has been made:</p>
            </div>
            <b-form-group
                label-for="client"
                label="Client:"
                label-cols="4"
                class="d-flex align-items-center"
            >
                <div class="col-form-label">
                    {{ client.firstname }} {{ client.lastname }}
                </div>
            </b-form-group>
            <b-form-group
                label-for="patient"
                label="Patient:"
                label-cols="4"
                class="d-flex align-items-center"
            >
                <div class="col-form-label">{{ patient.name }}</div>
            </b-form-group>
            <b-form-group
                label-for="item"
                label="Item:"
                label-cols="4"
                class="d-flex align-items-center"
            >
                <div class="col-form-label">{{ item.display_name }}</div>
            </b-form-group>
            <b-form-group
                label-for="deliveryOption"
                label="Delivery Option:"
                label-cols="4"
                class="d-flex align-items-center"
            >
                <div class="col-form-label">
                    {{ deliveryOption ? deliveryOption.value : "-" }}
                </div>
            </b-form-group>
            <b-form-group label-for="message" label="Message:" label-cols="4">
                <b-form-textarea
                    v-model="message"
                    placeholder="Message"
                    rows="3"
                    name="message"
                ></b-form-textarea>
            </b-form-group>
            <div slot="modal-footer" class="w-100">
                <b-button
                    @click="$refs.requestRefillModal.hide()"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <b-button
                        v-if="mode == null"
                        @click="reject"
                        variant="primary"
                        >Deny</b-button
                    >
                    <b-button
                        v-if="mode == null"
                        @click="approve"
                        variant="primary"
                        >Approve</b-button
                    >

                    <b-button
                        v-else-if="mode == 'APPROVE'"
                        @click="approve"
                        variant="primary"
                        >Approve</b-button
                    >

                    <b-button
                        v-else-if="mode == 'REJECT'"
                        @click="reject"
                        variant="primary"
                        >Deny</b-button
                    >
                </div>
                <!-- <div v-if="loading" class="float-right">
                    <img src="assets/ajax-loader.gif" />
                </div> -->
            </div>
        </b-modal>
    </div>
</template>
<style></style>

<script>
import Record from "@/services/records";

const APPROVE_STATUS = 1;
const REJECT_STATUS = 2;

export default {
    name: "ApproveRejectRequestRefill",
    props: {
        instanceId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            loading: true,
            request: {},
            requestId: null,
            title: "Refill Request",
            client: {},
            patient: {},
            item: {},
            deliveryOption: {},
            message: "",
            status: 0,
            mode: null
        };
    },

    methods: {
        open(param, mode) {
            this.$refs.requestRefillModal.show();
            this.request = param;
            this.requestId = param.id;
            this.client = param.client;
            this.patient = param.patient;
            this.item = param.item;
            this.mode = mode;
            this.deliveryOption = param.delivery_option;

            if (this.mode == "APPROVE") {
                this.title = "Approve Refill Request";
            } else if (this.mode == "REJECT") {
                this.title = "Deny Refill Request";
            }
        },
        async approve() {
            this.status = APPROVE_STATUS;
            this.save();
        },
        async reject() {
            this.status = REJECT_STATUS;
            this.save();
        },
        async save() {
            const errorMessage = "Error: Unable to update refill request";

            let param = {
                status: this.status,
                message: this.message
            };

            Record.updateRecordRefillRequest(this.requestId, param)
                .then(response => {
                    if (response.message.code == 200) {
                        if (this.status == APPROVE_STATUS) {
                            this.$emit("approved", this.request);
                        } else {
                            this.$emit("reload");
                        }

                        this.$refs.requestRefillModal.hide();
                        this._message(response.resource.message);
                    } else {
                        this._message(errorMessage, "danger");
                    }
                })
                .catch(error => {
                    this._message(errorMessage, "danger");
                    console.error(error);
                });
        }
    }
};
</script>
